'use client';
import { AnimationBackground } from '@/components/animation/AnimationBackground';
import { AnimationHover } from '@/components/animation/AnimationHover';
import { AnimationInitial } from '@/components/animation/AnimationInitial';
import { AnimationGestures } from '@/components/animation/AnimationGestures';
import { Button } from '@nextui-org/react';
import { Link } from '@/components/page-loader/link';

interface NotFoundStateProps {
  error: Error;
}
const NotFoundPage: React.FC<NotFoundStateProps> = ({ error }) => {
  return (
    <AnimationInitial>
      <div className="absolute w-screen h-screen bg-gradient-to-br from-rose-400 via-fuchsia-500 to-indigo-500">
        <AnimationBackground />
      </div>
      <section className="relative flex items-center w-screen h-screen">
        <div className="px-4 py-8 mx-auto lg:py-16 lg:px-6">
          <AnimationHover>
            <div className="mx-auto text-center">
              <h1 className="mb-4 font-extrabold tracking-tight text-7xl lg:text-9xl text-upgrade-pro">
                404
              </h1>
              <p className="mb-4 text-3xl font-bold tracking-tight text-gray-900 md:text-4xl dark:text-white">
                Something's missing.
              </p>
              <p className="mb-4 text-lg font-light text-dark">
                Sorry, we can't find that page. You'll find lots to explore on
                the home page.
              </p>
              <AnimationGestures>
                <Link href="/dashboard">
                  <Button color="primary">Back to Homepage</Button>
                </Link>
              </AnimationGestures>
            </div>
          </AnimationHover>
        </div>
      </section>
    </AnimationInitial>
  );
};

export default NotFoundPage;
